import { selectedResourceIdsByMasterIdSelector } from "./selectedResourceIdsByMasterIdSelector";
import { gridResourcesFlatDataSelector } from "../../resource-data/gridResourcesFlatDataSelector";
import { AllTypeResourceItem } from "../../../utils/types/resources";
import { RootState } from "@/store/store";

export const selectedResourcesByMasterIdSelector = (
  state: RootState,
  masterGridId: string,
): (AllTypeResourceItem | undefined)[] | undefined => {
  const resourceIds = selectedResourceIdsByMasterIdSelector(
    state,
    masterGridId,
  );
  const flatResources = gridResourcesFlatDataSelector(state, masterGridId);

  if (!flatResources || !resourceIds) {
    return;
  }

  return resourceIds?.map((id) => flatResources[id]);
};
